import axios, { AxiosRequestHeaders } from "axios";
import { getToken } from "./get-token";
import { getApiBaseUrl } from "@utils/getApiBaseUrl";
import Cookies from "js-cookie";
import { siteSettings } from "@settings/site-settings";
import * as Sentry from "@sentry/nextjs";

const BASE_URL = getApiBaseUrl();
const locale = Cookies.get("NEXT_LOCALE") || siteSettings.defaultLanguage || "en";

const http = axios.create({
  baseURL: `${BASE_URL}/${locale}/api`,
  timeout: 30000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

http.interceptors.request.use(
  (config) => {
    const token = getToken();
    config.headers = {
      ...config.headers,
      Authorization: token ? `Token ${token}` : "",
    } as AxiosRequestHeaders;
    return config;
  },
  (error) => {
    Sentry.captureException(error);
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      Sentry.captureException(new Error(`API Error: ${error.response.status} - ${error.response.data?.message || "Unknown Error"}`));
    } else if (error.request) {
      Sentry.captureException(new Error("API Error: No response received"));
    } else {
      Sentry.captureException(error);
    }

    return Promise.reject(error.response ? error.response.data : error.message);
  }
);

export default http;
